let resumeData = {
  "imagebaseurl":"http://connorkunstek.com/",
  "name": "Connor Kunstek",
  "role": "Solutions Architect"
  }
export default resumeData
